<template>
<div class="image-uploader">
  <label class="select-image">画像を選択
    <input type="file" accept="image/*" v-if="showFileTag" @change="onFileChange">
  </label>
  <input type="hidden" v-bind:name="hidden_id_name" v-bind:value="attachedImage.id">
  <div class="warning" v-if="uploading">アップロード中...</div>
  <div class="error" v-if="error">{{error_message}}</div>
  <div class="upload-image" v-if="attachedImage.id">
    <span class="info">{{attachedImage.width}}x{{attachedImage.height}}({{attachedImage.filesize}})</span>
    <label class="remove-image" @click="remove" v-if="attachedImage.id">削除</label>
  </div>
  <div class="preview-image" v-if="attachedImage.id">
    <img
      v-show="previewImage"
      :src="previewImage"
      alt=""
    />
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    image_id: {
      type: String,
      require: false,
      default: '0'
    },
    hidden_id_name: {
      type: String,
      require: false,
      default: 'image_id[]'
    }
  },
  data: function () {
    return {
      showFileTag: true,
      uploading: false,
      error: false,
      error_message: '',
      previewImage: null,
      attachedImage: {}
    }
  },
  created() {
    this.resetAttachedImage();

    const imageId = parseInt(this.image_id, 10);
    if(imageId > 0) {
      this.loadImage(imageId);
    }
  },
  methods: {
    // <input type="file">をリセットする
    // type="file"はreadonlyのため直接の変更は不可能
    // そこでv-ifで表示/非表示を切り替える事によりDOMの再生成を行う
    resetFileTag() {
      this.showFileTag = false;
      this.$nextTick(function () {
        this.showFileTag = true;
      })
      this.resetAttachedImage();
    },
    resetAttachedImage() {
      this.attachedImage = {
        id: 0,
        width: 0,
        height: 0,
        filesize: ''
      };
    },
    async loadImage(id) {
      const url = '/attached_image/' + id;
      try {
        const response = await axios.get(url);
        const data = response.data;
        this.attachedImage = data.image;
        this.createImageFromUrl(data.image.url);
      }catch(error) {
        this.uploading = false;

        const {
          status,
          statusText
        } = error.response;

        this.previewImage = false;
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];
      // ファイルを取得したら不要なのでリセット
      this.resetFileTag();

      this.createImage(file);
      this.uploadImage(file);
    },
    createImageFromUrl(url) {
      this.previewImage = url;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.previewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    remove() {
      this.previewImage = false;
      this.error = false;
      this.error_message = '';
      this.deleteImage();
      this.resetFileTag();
    },
    async deleteImage() {
      try {
        if(this.attachedImage.id <= 0) {
          return;
        }

        const url = '/attached_image/' + this.attachedImage.id;
        const response = await axios.delete(url);
      }catch(error) {
        const {
          status,
          statusText
        } = error.response;
        console.log("delete image failed: status=" + status + ", error=", error.response.data);
      }
    },
    async uploadImage(file) {
      this.uploading = true;
      this.error = false;

      try {
        const url = '/attached_image';

        const params = new FormData();
        params.append('file', file);

        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };

        const response = await axios.post(url, params, config);
        const data = response.data;
        this.uploading = false;
        this.attachedImage = data.image;
      }catch(error) {
        this.uploading = false;

        const {
          status,
          statusText
        } = error.response;

        this.error_message = error.response.data.error;
        this.error = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-uploader {
  padding: 0px;
  margin: 4px 0px 10px 0px;
}

label > input[type=file] {
  display: none;
}
label::after {
  content: '';
}

label {
  font-size: 100%;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #333;
  transition: .2s;

  &:hover {
    color: #ffffff;
    background-color: #333;
    text-decoration: none;
    cursor: pointer;
  }

  &.select-image {
    padding: 4px 20px 4px 20px;
  }

  &.remove-image {
    margin: 0px;
    padding: 4px 15px 4px 15px;
  }
}

.upload-image {
  width: 304px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  margin-bottom: 2px;

  .info {
    display: inline-block;
    flex: 1;
  }
  .remove-image {
  }
}

.preview-image {
  width: 302px;
  height: 302px;
  padding: 0;
  background: #e7e7e7;
  border: 1px solid #2E2F30;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    max-width: 300px;
    max-height: 300px;
  }
}

.error {
  color: #be0d0d;
  white-space: pre-wrap;
}

</style>
